// Body Check-In data. Each mood maps to a tiny ritual + acupressure + mantra.

export const MOODS = [
  {
    id: "tight",
    label: "Tight",
    hint: "Jaw, shoulders, body braced",
    color: "#3A5A40",
    ritual: "Stand. Roll the shoulders back and down 3×. Open the mouth wide as if yawning. Soften the tongue away from the roof of the mouth. Notice space.",
    point: { n: "GB 20 (Feng Chi)", how: "Base of skull, two thumb-widths from spine. Slow circles for 30 seconds." },
    mantra: "I bend so I do not break.",
    element: "Wood",
  },
  {
    id: "tired",
    label: "Tired",
    hint: "Heavy limbs, fading focus",
    color: "#A67C52",
    ritual: "Sit with both feet on the floor. Rub the palms together until warm. Cup the warm hands over the closed eyes for 60 seconds. Breathe slowly.",
    point: { n: "ST 36 (Zu San Li)", how: "Four fingers below knee, one finger lateral to shin. Press 1 minute, each side." },
    mantra: "Rest is medicine, not retreat.",
    element: "Earth",
  },
  {
    id: "anxious",
    label: "Anxious",
    hint: "Racing thoughts, fluttery chest",
    color: "#B8866D",
    ritual: "Place one hand on the heart, one on the belly. Exhale for a count of 7. Inhale for 4. Repeat 5 times. Let the exhale be longer than the inhale.",
    point: { n: "PC 6 (Nei Guan)", how: "Three finger-widths below the inner wrist. Steady pressure for 1 minute." },
    mantra: "I am safe in this moment. The next moment will arrive.",
    element: "Fire",
  },
  {
    id: "foggy",
    label: "Foggy",
    hint: "Can't focus, scattered",
    color: "#6B7A66",
    ritual: "Stand tall. Take 5 audible sighs out. Splash cold water on the wrists. Drink one full glass of warm water, slowly.",
    point: { n: "Yintang", how: "Between the eyebrows. Soft press, slow circles for 1 minute." },
    mantra: "Clarity arrives when I stop chasing it.",
    element: "Metal",
  },
  {
    id: "achy",
    label: "Achy",
    hint: "Body sore, stiff",
    color: "#2F4858",
    ritual: "Lie down. Knees bent, feet flat. Sway the knees gently side-to-side for 60 seconds. Let the lower back release into the floor.",
    point: { n: "KD 3 (Tai Xi)", how: "Inner ankle, midway between bone and Achilles. Press 1 minute, each side." },
    mantra: "My body is asking, not punishing.",
    element: "Water",
  },
  {
    id: "good",
    label: "Good",
    hint: "Steady, present, alive",
    color: "#3A5A40",
    ritual: "Take a moment of gratitude. Notice three things you can see, hear, and feel. Mark this state — it is data your body can return to.",
    point: { n: "CV 17 (Shan Zhong)", how: "Centre of chest, between the nipples. Soft hand for 1 minute." },
    mantra: "I trust this. I let it stay.",
    element: "Earth",
  },
];

export const MOOD_BY_ID = MOODS.reduce((acc, m) => ({ ...acc, [m.id]: m }), {});
